/*
* Convert session storage's queryString to Object (Key Value)
* queryString in sessionStorage stores the query params passed to Onboarding App
* this method returns key value object created from queryString params
* */
export function fetchQueryParamsFromSession() {
  let storageItem = sessionStorage.getItem('queryString');
  let sessionObject = {};
  if(storageItem) {
    const queryString = storageItem.split('?')[1];
    // convert query key value to js object
    if(queryString) {
      const queryParams = queryString.split('&');
      for(const parms of queryParams) {
        const keyValue = parms.split('=');
        sessionObject[keyValue[0]] = keyValue[1];
      }
    }
  }
  return sessionObject;
}

/**
 * utility for conditionally joining classNames together
 * @param  {Object} conditionalClass with property as css class and value as boolean
 * @return {String} return joining css classnames whose value is true in conditionalClass
 */
export function classNames(conditionalClass = {}) {
  return Object.keys(conditionalClass)
    .filter(cssClass => conditionalClass[cssClass])
    .join(' ');
}
